import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  containerHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  containerLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  imageLogo: {
    height: 70,
    width: 70,
  },
  titleText: {
    fontWeight: 700,
    fontSize: 20,
    textTransform: 'uppercase',
  },
  containerAddress: {
    display: 'flex',
    marginTop: 10,
    marginHorizontal: 20,
  },
  addressText: {
    textAlign: 'center',
    fontSize: 11,
  },
  containerPhones: {
    display: 'flex',
  },
  phonesText: {
    textAlign: 'center',
    fontSize: 11,
  },
});
